import { Preferences } from '@capacitor/preferences'
import * as types from '../mutation-types'

// Helper functions for Preferences
async function getPreference(key) {
  const result = await Preferences.get({ key });
  return result.value ? JSON.parse(result.value) : null;
}

async function setPreference(key, value) {
  return await Preferences.set({ key, value: JSON.stringify(value) });
}

// state
export const state = {
  cameraStopped: false
}

// Initialize state from preferences
getPreference('cameraStopped').then((cameraStopped) => {
  if (cameraStopped !== null) {
    state.cameraStopped = cameraStopped
  }
})

// getters
export const getters = {
  cameraStopped: state => state.cameraStopped
}

// mutations
export const mutations = {
  [types.SET_CAMERA_STOPPED](state, { cameraStopped }) {
    state.cameraStopped = cameraStopped
  }
}

// actions
export const actions = {
  async setCameraStopped({ commit }, cameraStopped) {
    commit(types.SET_CAMERA_STOPPED, { cameraStopped })
    await setPreference('cameraStopped', cameraStopped)
  },
  
  async getCameraState() {
    return await getPreference('cameraStopped')
  }
}